module.exports = __webpack_public_path__ + "img/etf-cover.1ac39d78.jpg";